module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Bio-bibliographische Nachweise")]), _vm._v(" "), _c('dl', [_vm._l((_vm.sources), function(item) {
    return [_c('dt', [_vm._v(_vm._s(item.code))]), _vm._v(" "), (item.author) ? _c('dd', [_vm._v(_vm._s(item.author))]) : _vm._e(), _vm._v(" "), (item.publisher) ? _c('dd', [_vm._v(_vm._s(item.publisher) + " (Hrsg.)")]) : _vm._e(), _vm._v(" "), _c('dd', [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.pages) ? _c('dd', [_vm._v("S. " + _vm._s(item.pages))]) : _vm._e(), _vm._v(" "), (item.publication) ? _c('dd', [_vm._v(_vm._s(item.publication))]) : _vm._e(), _vm._v(" "), (item.notes) ? _c('dd', [_c('i', [_vm._v(_vm._s(item.notes))])]) : _vm._e()]
  })], 2), _vm._v(" "), _c('table', {
    staticClass: "noprint",
    attrs: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tr', [_c('td', [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Datenbank durchsuchen")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('hr', {
    attrs: {
      "size": "1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35642f5f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SourceList.vue
// module id = 91
// module chunks = 1